import device from '@/utils/device';
import store from '@/store';
import type { SettingType, ConfigurationVo } from './../types/setting.d';
import { getActivityStatusV1 } from '@/api';

export const useSetting = defineStore(
  'setting',
  () => {
    const state = reactive<SettingType>({
      configuration: {
        countryCode: '',
        countryName: '',
        currencyList: [],
        defaultLanguage: '',
        defaultCurrency: '',
        languages: [],
        recommendLanguage: '',
        recommendLanguageLocalName: '',
        recommendLanguagePopTitle: {
          weThinkLocalName: '',
          languageLocalName: '',
          seeLocalName: '',
          buttonName: ''
        }
      },
      draw: {
        /**
         * 活动结束时间
         */
        endTime: 0,
        /**
         * 活动开始时间
         */
        startTime: 0,
        /**
         * -1-不存在活动 0-未开始 1-进行中 2-已结束
         */
        status: 0
      },
      ugc: {
        /**
         * 活动结束时间
         */
        endTime: 0,
        /**
         * 活动开始时间
         */
        startTime: 0,
        /**
         * -1-不存在活动 0-未开始 1-进行中 2-已结束
         */
        status: 0
      },
      acquire: {
        /**
         * 活动结束时间
         */
        endTime: 0,
        /**
         * 活动开始时间
         */
        startTime: 0,
        /**
         * -1-不存在活动 0-未开始 1-进行中 2-已结束
         */
        status: 0
      },
      firstOrder: {
        /**
         * 活动结束时间
         */
        endTime: 0,
        /**
         * 活动开始时间
         */
        startTime: 0,
        /**
         * -1-不存在活动 0-未开始 1-进行中 2-已结束
         */
        status: 0,
        /**
         * banner路由入口
         */
        bannerEntrance: []
      },
      freeCoins: {
        /**
         * 活动结束时间
         */
        endTime: 0,
        /**
         * 活动开始时间
         */
        startTime: 0,
        /**
         * -1-不存在活动 0-未开始 1-进行中 2-已结束
         */
        status: 0
      },
      flipCard: {
        /**
         * 活动结束时间
         */
        endTime: 0,
        /**
         * 活动开始时间
         */
        startTime: 0,
        /**
         * -1-不存在活动 0-未开始 1-进行中 2-已结束
         */
        status: 0,
        bannerEntrance: []
      },
      freeRobux: {
        /**
         * 活动结束时间
         */
        endTime: 0,
        /**
         * 活动开始时间
         */
        startTime: 0,
        /**
         * -1-不存在活动 0-未开始 1-进行中 2-已结束
         */
        status: 0,
        bannerEntrance: []
      },
      theme: undefined,
      fcCoinsVersion: false,
      device: {
        isMobileOrTablet: false,
        isMobile: false,
        isIos: false,
        isAndroid: false
      },
      ratio: {
        mobile: false,
        pc: false,
        ipad: false
      },
      isBrowse: undefined,
      drawInteraction: undefined,
      drawPopupEntrance: undefined,
      bannerEntrancePath: '/', //顶部横幅活动入口
      popupEntrancePath: '/', //弹窗活动入口
      iconEntrancePath: '/', //icon悬浮活动入口
      // 免费金币活动 新手引导
      freeCoinsGuide: true // false-隐藏  true-现实
    });
    // 添加主题
    const addTheme = (data: string) => {
      state.theme = data;
    };
    // 添加多语言 国家配置等
    const addConfiguration = (data: ConfigurationVo) => {
      state.configuration = data;
    };
    // 活动时间配置
    const activityStatus = () => {
      getActivityStatusV1().then(res => {
        if (res.code === 200) {
          state.draw = res.data.draw;
          state.ugc = res.data.ugc;
          state.acquire = res.data.acquire;
          state.firstOrder = res.data.firstOrder;
          state.freeCoins = res.data.freeCoins;
          state.freeRobux = res.data.freeRobux;
          state.flipCard = res.data.flipCard;
        }
      });
    };
    /**
     * 设置活动弹窗与悬浮弹窗数据对象 type 1-悬浮弹窗 2-活动弹窗
     * @param data {route:string,browseTime:number}
     * @param type 1-悬浮弹窗 2-活动弹窗
     */
    const setActivityInteractionData = (data: any, type: string) => {
      console.log('setActivityInteractionData=================>', data, type);
      if (type == 'iconEntranceList') state.drawInteraction = data;
      if (type == 'popupEntranceList') state.drawPopupEntrance = data;
    };

    const toggleVersion = () => {
      state.fcCoinsVersion = !state.fcCoinsVersion;
    };
    // 初始化设备，通过设备判断
    const initDevice = () => {
      window.addEventListener('resize', () => {
        const { isMobileOrTablet, isMobile, isIos, isAndroid } = device();
        state.device = {
          isMobileOrTablet,
          isMobile,
          isIos,
          isAndroid
        };
        // console.log(`移动桌面=>${isMobileOrTablet}; 移动端=>${isMobile}; IOS=>${isIos}; Android=>${isAndroid}`);
      });
    };
    // 通过分辨率判断 只区分移动设备（ipad，mobile）和 桌面（pc）设备
    const initRatio = () => {
      const setRatio = () => {
        const screenWidth = window.innerWidth;
        if (screenWidth >= 992) {
          state.ratio = { pc: true, mobile: false, ipad: false };
        } else if (screenWidth < 768) {
          state.ratio = { pc: false, mobile: true, ipad: false };
        } else {
          state.ratio = { pc: false, mobile: true, ipad: true };
        }
        // console.log(`移动桌面=>${this.ratio.pc}; 移动端=>${this.ratio.mobile}; ipad=>${this.ratio.ipad};`);
      };
      setRatio();
      window.addEventListener('resize', setRatio);
    };
    return {
      state,
      addTheme,
      addConfiguration,
      activityStatus,
      toggleVersion,
      initDevice,
      initRatio,
      setActivityInteractionData
    };
  },
  {
    persist: {
      storage: sessionStorage || undefined
    }
  }
);

export const useSettingsStore = () => {
  return useSetting(store);
};
